import { withRouter } from 'next/router';
import React from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { createStructuredSelector } from 'reselect';
import clsx from 'clsx';
import {
  assetSelect,
  assetSelectIndex,
  checkBookmarkData,
  downloadPhoto,
  nicePhoto,
  showAttributeModal,
  saveBookmark,
} from './actions';
import OtherImages from './OtherImages';
import PremiumHint from './PremiumHint';
import {
  makeSelectAssetSelected,
  makeSelectBookmarkData,
  makeSelectCategoryDesign,
  makeSelectCategorySimilar,
  makeSelectCollection,
  makeSelectCreator,
  makeSelectDataType,
  makeSelectDesignSimilar,
  makeSelectDownloadingPhoto,
  makeSelectDownloadPhotoLoading,
  makeSelectGotIt,
  makeSelectId,
  makeSelectIllustSimilar,
  makeSelectModalAttribute,
  makeSelectNeighbor,
  makeSelectPhoto,
  makeSelectPhotoAssets,
  makeSelectPhotoBase64,
  makeSelectPhotoCategories,
  makeSelectPhotoNice,
  makeSelectPhotoPath,
  makeSelectPhotoPreview,
  makeSelectPhotoSimilar,
  makeSelectPhotoTags,
  makeSelectPhotoThumbnail,
  makeSelectPhotoTitle,
  makeSelectPowerPoint,
  makeSelectSameCreator,
  makeSelectSilhouetteSimilar,
  makeSelectStatistics,
  selectDetailPhoto,
  selectSimilar,
} from './selectors';
import ImageInformation from './ImageInformation';
import SimilarOtherService from './SimilarOtherService';
import withI18next from '~/../hocs/_withI18next';
import AdsensePreview from '~/components/AdsensePreview';
import AttributeModal from '~/components/AttributeModal';
import Container from '~/components/Container';
import GoogleAds from '~/components/GoogleAds336';
import I18nLink from '~/components/I18nLink';
import ImagesPreview from '~/components/ImagesPreview';
import LoadingDefault from '~/components/LoadingDefault';
import PhotoDownload from '~/components/PhotoDownload';
import PhotoTagsNew from '~/components/PhotoTagsNew';
import PowerpointPreview from '~/components/PowerpointPreview';
import IconLikeDefault from '~/components/svg/icon-like-default.svg';
import IconLikeDesignACHover from '~/components/svg/icon-like-design-ac-hover.svg';
import IconLikeDesignAC from '~/components/svg/icon-like-design-ac.svg';
import IconLikeIllustACHover from '~/components/svg/icon-like-illust-ac-hover.svg';
import IconLikeIllustAC from '~/components/svg/icon-like-illust-ac.svg';
import IconLikePhotoACHover from '~/components/svg/icon-like-photo-ac-hover.svg';
import IconLikePhotoAC from '~/components/svg/icon-like-photo-ac.svg';
import IconLikeSilhouetteACHover from '~/components/svg/icon-like-silhouette-ac-hover.svg';
import IconLikeSilhouetteAC from '~/components/svg/icon-like-silhouette-ac.svg';
import IconBookmark from '~/components/svg/icon-bookmark.svg';
import IconBookmarked from '~/components/svg/bookmarked-icon.svg';
import { loadPhotosInCart } from '~/containers/Layout/actions';
import TimeDownload from '~/components/TimeDownload';
import ToastPhotoDownloading from '~/components/ToastPhotoDownloading';
import UserChecking from '~/components/UserChecking';
import WebTemplatesPreview from '~/components/WebTemplatesPreview';
import Config, { keyConfig } from '~/config';
import {
  makeSelectIsAuthenticated,
  makeSelectProfile,
} from '~/containers/AuthProvider/selectors';
import ExtraLicensePaymentModal from '~/containers/ExtraLicensePaymentModal';
import {
  makeSelectLoadingExtraLicensePayment,
  makeSelectModal,
} from '~/containers/ExtraLicensePaymentModal/selectors';
import { makeSelectPatterns } from '~/containers/HomePage/selectors';
import { makeSelectCurrentLanguage } from '~/containers/Language/selectors';
import {
  makeSelectCurrentLang,
  makeSelectServiceType,
} from '~/containers/MetadataProvider/selectors';
import { makeSelectIsTrial } from '~/containers/RegisterPremiumPage/selectors';
import themeVariables from '~/shared/themeVariables';
import { slugs } from '~/utils';
import { SERVICE_TYPES } from '~/utils/constants';
import NewSurvey from '~/components/NewSurvey';
import { redirectLogin } from '~/utils/redirect';
import Comment from '~/containers/Comment';
import { loadCommentsData } from '~/containers/Comment/actions';

const roles = Config.getRoles();

const ICON_LIKE_BY_SERVICE = {
  [SERVICE_TYPES.PHOTO_AC]: IconLikePhotoAC,
  [SERVICE_TYPES.ILLUST_AC]: IconLikeIllustAC,
  [SERVICE_TYPES.SILHOUETTE_AC]: IconLikeSilhouetteAC,
  [SERVICE_TYPES.DESIGN_AC]: IconLikeDesignAC,
};
const IconLikeService = ICON_LIKE_BY_SERVICE[Config.serviceType];

const ICON_LIKE_BY_SERVICE_HOVER = {
  [SERVICE_TYPES.PHOTO_AC]: IconLikePhotoACHover,
  [SERVICE_TYPES.ILLUST_AC]: IconLikeIllustACHover,
  [SERVICE_TYPES.SILHOUETTE_AC]: IconLikeSilhouetteACHover,
  [SERVICE_TYPES.DESIGN_AC]: IconLikeDesignACHover,
};
const IconLikeServiceHover = ICON_LIKE_BY_SERVICE_HOVER[Config.serviceType];

@withRouter
@withI18next()
class IllustContainer extends React.Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.wrapperRef = React.createRef();
    this.shareBtnRef = React.createRef();
    this.commentContainerRef = React.createRef();
    this.state = {
      showSupportMessage: false,
      showContainerShare: false,
      showAds: true,
      showActionShareSocial: false,
      isCheckBookmark: true,
      numberClickBookmark: 0,
      isLoadCommentData: true,
      checkScrollComment: false,
      stateCheckCallDataComment: true,
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('scroll', this.onScroll);
  }

  componentDidUpdate(prevProps) {
    const {
      downloadingPhoto,
      id,
      loadPhotosInCart,
      photo,
      profile,
      checkBookmarkData,
    } = this.props;

    if (
      downloadingPhoto &&
      !toast.isActive('toast.downloading') &&
      !Config.isIllustAC()
    ) {
      toast.success(<ToastPhotoDownloading />, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
        toastId: 'toast.downloading',
      });
    }

    if (id && prevProps.id && id !== prevProps.id) {
      this.setState({
        showSupportMessage: false,
      });
      loadPhotosInCart();
    }
    // Remove comment to release bookmark feature
    // if (profile?.id && this.state.isCheckBookmark) {
    //   checkBookmarkData(photo.id);
    //   this.setState({
    //     isCheckBookmark: false,
    //   });
    // }
    // if (this.state.isLoadCommentData) {
    //   this.props.loadCommentsData({
    //     data_id: this.props.id,
    //     user_id: this.props.profile.id || null,
    //   });
    //   this.setState({ isLoadCommentData: false });
    // }
    if (this.state.checkScrollComment && this.state.stateCheckCallDataComment) {
      this.props.loadCommentsData({
        data_id: this.props.id,
        user_id: this.props.profile.id || null,
      });
      this.setState({ stateCheckCallDataComment: false });
    }
  }

  onScroll = () => {
    if (this.commentContainerRef?.current) {
      // console.log('hihi ne', this.commentContainerRef?.current);
      const {
        scrollTop,
        scrollHeight,
        clientHeight,
        offsetTop,
      } = this.commentContainerRef?.current;

      // if (scrollTop + clientHeight === scrollHeight) {
      //   console.log('reached comment container');
      // }
      if (window && window?.scrollY > offsetTop - 800) {
        this.setState({
          checkScrollComment: true,
        });
      }
    }
  };

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('scroll', this.onScroll);
  }

  handleScroll = () => {
    this.setState({
      showActionShareSocial: false,
    });
  };

  onAssetsSizeSelect = (asset, index) => {
    if (asset.price.with_tax === 0 || this.props.isAuthenticated) {
      this.props.assetSelectIndex(index);
      return this.props.assetSelect(index);
    }

    redirectLogin(this.props.lng);
    this.props.assetSelectIndex(index);
  };

  onDownload = () => {
    if (!this.props.assets || !this.props.assets[this.props.assetSelected]) {
      return;
    }
    this.props.downloadPhoto({
      id: this.props.id,
      type: this.props.assets[this.props.assetSelected].type,
      format: this.props.assets[this.props.assetSelected].format,
      paymentID: '',
      payerID: '',
      paymentToken: '',
      userIdforLog: this.props.profile.user_id,
    });
  };

  onSocialShare = (link) => {
    window.open(
      link,
      'share',
      `height=450, width=550, top=${window.innerHeight / 2 - 275}, left=${
        window.innerWidth / 2 - 225
      }, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0`,
    );
  };

  nicePhoto = () => {
    this.props.nicePhoto(this.props.id);
  };

  saveBookmark = () => {
    const { photo, profile, lng, saveBookmark } = this.props;
    const { numberClickBookmark } = this.state;

    if (!profile?.id) return;
    this.setState(
      {
        numberClickBookmark: numberClickBookmark + 1,
      },
      () => {
        if (numberClickBookmark > 2) return;
        saveBookmark({
          dataID: photo.id,
          lng,
        });
      },
    );
  };

  onClickImage = (item, lang) => {
    let url = `/${lang}/${keyConfig.get('route_detail_page')}/${item.id}`;

    if (item.title !== '') {
      url = `/${lang}/${keyConfig.get('route_detail_page')}/${item.id}/${
        item.title
      }`;
    }

    window.open(url, '_blank');
  };

  properties = (properties) => {
    const [assets] = this.props.assets;
    return (assets.type = properties);
  };

  calculateTopSticky() {
    const { hasTrial } = this.props;
    let base = 75;
    if (hasTrial) {
      base += 75;
    }

    return base;
  }

  buildNextNeighbor(params) {
    const { currentLanguage } = this.props;
    const [neighbor] = params;
    const nextImage = neighbor.next;
    if (!nextImage) {
      return false;
    }
    return {
      id: nextImage.id,
      title: Config.getTitleByLanguage(nextImage.title, currentLanguage),
    };
  }

  buildPrevNeighbor(params) {
    const { currentLanguage } = this.props;
    const [neighbor] = params;
    const prevImage = neighbor.previous;
    if (!prevImage) {
      return false;
    }
    return {
      id: prevImage.id,
      title: Config.getTitleByLanguage(prevImage.title, currentLanguage),
    };
  }

  handleToggleSupportMessage = () => {
    this.setState((state) => ({
      showSupportMessage: !state.showSupportMessage,
    }));
  };

  onToggleSupportMessage = () => {
    this.setState({
      showSupportMessage: true,
    });
  };

  canShowAds = () => {
    const { categories, profile } = this.props;
    const hasNoAdsCategory = categories.some(
      (item) => item.id === 22 || item.id === 23,
    );
    if (hasNoAdsCategory) return false;
    return profile.role !== roles.PREMIUM;
  };

  renderNeighborLinks = () => {
    const { neighbor, lng, t } = this.props;
    if (neighbor && neighbor[0]) {
      return (
        <div className="next-similar">
          <I18nLink
            href={`/${keyConfig.get('route_detail_page')}/${
              this.buildPrevNeighbor(neighbor).id
            }${
              this.buildPrevNeighbor(neighbor).title &&
              `/${slugs.makeSlug(this.buildPrevNeighbor(neighbor).title, {
                lang: lng,
              })}`
            }`}
          >
            <a
              className={`link-creator ${Config.serviceType} ${
                !this.buildPrevNeighbor(neighbor) ? 'disabled' : ''
              }`}
            >
              {t(Config.getPrefixContent('previous_image'))}
            </a>
          </I18nLink>

          <I18nLink
            href={`/${keyConfig.get('route_detail_page')}/${
              this.buildNextNeighbor(neighbor).id
            }${
              this.buildNextNeighbor(neighbor).title &&
              `/${slugs.makeSlug(this.buildNextNeighbor(neighbor).title, {
                lang: lng,
              })}`
            }`}
          >
            <a
              className={`link-creator ${Config.serviceType} ${
                !this.buildNextNeighbor(neighbor) ? 'disabled' : ''
              }`}
            >
              {t(Config.getPrefixContent('next_image'))}
            </a>
          </I18nLink>
          <style jsx>
            {`
              .next-similar {
                margin-top: 16px;
              }
              .link-creator {
                font-weight: 700;
              }
              .link-creator:hover {
                opacity: 0.9 !important;
                text-decoration: underline !important;
              }
            `}
          </style>
        </div>
      );
    }
    return null;
  };

  renderSimilarUrl = (item) => {
    const { lng } = this.props;
    const detailPath = Config.detailPagePath[Config.serviceType];

    let url = '';
    const photoTitle = Config.getTitleByLanguage(item.title, lng);

    url = `/${detailPath}/${item.id}`;
    if (photoTitle) {
      const slugTitle = slugs.makeSlug(photoTitle, { lang: lng });
      url = `/${detailPath}/${item.id}/${slugTitle}`;
    }

    return url;
  };

  renderSimilarThisService = () => {
    const { collection, t, lng, photo } = this.props;
    console.log('photophoto', photo);
    let keyword = '';
    if (photo?.tags?.length > 0) {
      keyword = photo.tags[0][`name_${lng === 'jp' ? 'ja' : lng}`];
    }

    return (
      <>
        <div className="similar-service-container desktop">
          <h3 className="similar-service-title">
            {t('ill_download_page_similar')}
          </h3>
          <div className="similar-service-photo-wrapper">
            {collection.map((item, index) => (
              <div key={item.id} className="similar-service-image">
                <I18nLink prefetch={false} href={this.renderSimilarUrl(item)}>
                  <a target="_blank">
                    <img
                      data-src={item.thumbnail}
                      alt={Config.getTitleByLanguage(item.title, lng)}
                      className="lazyload similar-service-image-item"
                    />
                  </a>
                </I18nLink>
                {index === collection.length - 1 && (
                  <I18nLink
                    host={Config.getSiteURL(Config.serviceType)}
                    href={`/search-result/similar/${
                      photo?.id || item?.id
                    }?service_type_for_similar=${
                      Config.serviceType
                    }&keyword=${keyword}`}
                  >
                    <a target="_blank" rel="noreferrer">
                      <span className="similar-service-see-more">
                        {t('view_all')}
                      </span>
                    </a>
                  </I18nLink>
                )}
              </div>
            ))}
          </div>
        </div>
        <style jsx>
          {`
            .similar-service-container {
              margin: 8px 0 16px;
              width: 100%;
            }
            .similar-service-title {
              font-weight: 600;
              font-size: 20px;
              line-height: 23px;
              color: #170507;
              margin: 16px 0;
            }
            .similar-service-photo-wrapper {
              display: grid;
              grid-column: 1 / 5;
              grid-template-columns: repeat(5, 1fr);
              width: 100%;
              grid-gap: 8px;
            }
            .similar-service-image {
              position: relative;
              height: 160px;
              width: 100%;
              border: 1px solid #7a7a7a;
              border-radius: 4px;
              overflow: hidden;
            }
            .similar-service-image-item {
              height: 160px;
              width: 100%;
              object-fit: contain;
            }
            .similar-service-see-more {
              display: flex;
              align-items: center;
              justify-content: center;
              position: absolute;
              width: 100%;
              height: 160px;
              background: linear-gradient(
                0deg,
                rgba(0, 0, 0, 0.68),
                rgba(0, 0, 0, 0.68)
              );
              top: 0;
              left: 0;
              font-weight: 700;
              font-size: 16px;
              line-height: 28px;
              color: #ffffff;
            }
            @media (max-width: ${themeVariables.breakpoints.mobile
                .maxWidth}px) {
              .similar-service-photo-wrapper {
                position: relative;
                overflow-x: scroll;
                display: flex;
                -webkit-overflow-scrolling: touch;
                scroll-behavior: smooth;
                -webkit-scroll-snap-points-x: repeat(240px);
                -ms-scroll-snap-points-x: repeat(240px);
                scroll-snap-points-x: repeat(240px);
                -webkit-scroll-snap-type: mandatory;
                -ms-scroll-snap-type: mandatory;
                scroll-snap-type: mandatory;
              }
              .similar-service-image {
                width: 240px;
                flex-shrink: 0;
              }
              .similar-service-container {
                padding: 0 16px;
                font-size: 18px;
              }
              .similar-service-title {
                font-size: 18px;
              }
            }
          `}
        </style>
      </>
    );
  };

  renderDataSection = () => {
    const {
      tags,
      title,
      categories,
      path,
      thumbnail,
      lng,
      dataType,
      powerPoint,
      photo,
      profile,
      isAuthenticated,
      t,
    } = this.props;
    let { imagesPreview } = this.props;
    const { showSupportMessage } = this.state;

    const keywords = Config.getTitleByLanguage(photo.title, lng);

    if (!Config.isDesignAC() && imagesPreview.length < 1) {
      imagesPreview = imagesPreview.concat({ path, thumbnail });
    }

    let previewComponent;
    let hasMaxWidth;

    switch (dataType) {
      case 'ppt':
        previewComponent = <PowerpointPreview powerPoint={powerPoint} />;
        hasMaxWidth = true;
        break;
      case 'wtp':
        previewComponent = <WebTemplatesPreview images={imagesPreview} />;
        hasMaxWidth = true;
        break;
      case 'ads':
        previewComponent = <AdsensePreview images={imagesPreview} />;
        hasMaxWidth = false;
        break;
      default:
        previewComponent = (
          <ImagesPreview
            images={imagesPreview}
            description={title}
            keywords={keywords}
            tags={tags}
            showSupportMessage={showSupportMessage}
            onToggleSupportMessage={this.handleToggleSupportMessage}
            isAuthenticated={isAuthenticated}
            profile={profile}
            photo={photo}
          />
        );
        hasMaxWidth = false;
    }

    return (
      <div className="bg-white">
        <Container>
          <div className="photo-wrapper">
            <div className="photo-section-left">
              {previewComponent}
              {this.renderActionImage()}
              {this.renderNeighborLinks()}
            </div>
            <div className="sticky-right">
              <div
                className="photo-section-right"
                style={{ top: this.calculateTopSticky() }}
              >
                {this.canShowAds() && (
                  <div className="google-ads-container">
                    <GoogleAds />
                  </div>
                )}
                {photo && (
                  <PhotoDownload
                    photo={photo}
                    onToggleSupportMessage={this.onToggleSupportMessage}
                  />
                )}
              </div>
            </div>
          </div>
          <div>
            {this.renderSimilarThisService()}
            <ImageInformation
              profile={profile}
              photo={photo}
              t={t}
              title={title}
              tags={tags}
              hasMaxWidth={hasMaxWidth}
              categories={categories}
              lng={lng}
            />
          </div>
        </Container>
        <style jsx>
          {`
            .google-ads-container {
              width: 400px;
              height: 280px;
              margin-bottom: 14px;
            }
            .photo-section-left {
              width: calc(100% - 424px); // 424px = width of sticky right
            }
            @media (max-width: ${themeVariables.breakpoints.mobile
                .maxWidth}px) {
              .google-ads-container {
                height: 0 !important;
              }
            }
          `}
        </style>
      </div>
    );
  };

  renderDataSectionMobile = () => {
    const {
      tags,
      title,
      categories,
      path,
      thumbnail,
      lng,
      dataType,
      powerPoint,
      photo,
      profile,
      isAuthenticated,
    } = this.props;
    let { imagesPreview } = this.props;
    const { showSupportMessage } = this.state;
    const keywords = Config.getTitleByLanguage(photo.title, lng);

    if (!Config.isDesignAC() && imagesPreview.length < 1) {
      imagesPreview = imagesPreview.concat({ path, thumbnail });
    }

    if (Config.isDesignAC() && categories && categories[0]) {
      switch (categories[0].id) {
        case 15:
          this.properties('PPT');
          break;
        case 5:
        case 7:
        case 4:
        case 16:
          this.properties('PSD, PNG, JPG');
          break;
        case 12:
          this.properties('ABR, AI, JPG, PNG');
          break;
        default:
          this.properties('AI, PNG, JPG');
          break;
      }
    }

    let previewComponent;
    let hasMaxWidth;

    switch (dataType) {
      case 'ppt':
        previewComponent = <PowerpointPreview powerPoint={powerPoint} />;
        hasMaxWidth = true;
        break;
      case 'wtp':
        previewComponent = <WebTemplatesPreview images={imagesPreview} />;
        hasMaxWidth = true;
        break;
      case 'ads':
        previewComponent = <AdsensePreview images={imagesPreview} />;
        hasMaxWidth = false;
        break;
      default:
        previewComponent = (
          <ImagesPreview
            images={imagesPreview}
            description={title}
            keywords={keywords}
            tags={tags}
            showSupportMessage={showSupportMessage}
            onToggleSupportMessage={this.handleToggleSupportMessage}
            isAuthenticated={isAuthenticated}
            profile={profile}
            photo={photo}
          />
        );
        hasMaxWidth = false;
    }

    return (
      <div className="bg-white">
        <Container>
          <div className="photo-wrapper">
            <div className="photo-section-left">
              {previewComponent}
              {this.renderNeighborLinks()}
              <div className="sticky-right">
                <div
                  className="photo-section-right"
                  style={{ top: this.calculateTopSticky() }}
                >
                  {this.canShowAds() && (
                    <div className="google-ads-container">
                      <GoogleAds />
                    </div>
                  )}
                  {photo && (
                    <PhotoDownload
                      photo={photo}
                      onToggleSupportMessage={this.onToggleSupportMessage}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </Container>
        {this.renderSimilarThisService()}

        <Container>
          <PremiumHint />
          <PhotoTagsNew
            tags={tags}
            itemsToShow={15}
            categories={categories}
            hasMaxWidth={hasMaxWidth}
          />
        </Container>

        <style jsx>
          {`
            .photo-section-left {
              width: 100%;
            }
            .google-ads-container {
              width: 400px;
              height: 198px !important;
              margin-bottom: 14px;
            }
            @media (max-width: ${themeVariables.breakpoints.mobile
                .maxWidth}px) {
              .google-ads-container {
                height: 0 !important;
              }
            }
          `}
        </style>
      </div>
    );
  };

  renderNoData = () => {
    const { t } = this.props;
    return (
      <h3
        className="bg-gray text-center"
        style={{ padding: '100px 15px', marginBottom: 0, marginTop: 0 }}
      >
        <strong style={{ fontSize: 20 }}>
          {t(Config.getPrefixContent('no_image_detail_page'))}
        </strong>
      </h3>
    );
  };

  renderTitleSimilar = (serviceType) => {
    const { t } = this.props;
    serviceType = serviceType || this.props.serviceType;

    return t(
      `${Config.getPrefix(
        serviceType,
      )}_title_similar_detail_service_full_title`,
    );
  };

  renderSimilarDataSection = () => {
    const {
      id,
      collection,
      serviceType,
      categorySimilar,
      similar,
      photo,
      lng,
    } = this.props;

    let keyword = '';
    if (photo?.tags?.length > 0) {
      keyword = photo.tags[0][`name_${lng === 'jp' ? 'ja' : lng}`];
    }

    if (serviceType === SERVICE_TYPES.DESIGN_AC) {
      if (!categorySimilar) return null;
      return (
        <OtherImages
          title={this.renderTitleSimilar()}
          collection={collection}
          as={`/category/${categorySimilar.category_slug}`}
          href={{
            pathname: '/category',
            query: { slug: categorySimilar.category_slug },
          }}
          loading={similar.loading}
        />
      );
    } else {
      return (
        <OtherImages
          title={this.renderTitleSimilar()}
          collection={collection}
          href={{ pathname: '/similar', query: { data_id: id } }}
          as={`/search-result/similar/${id}?keyword=${keyword}`}
          loading={similar.loading}
        />
      );
    }
  };

  renderSameCreatorDataSection = () => {
    const { t, id, sameCreator: collection, lng, photo } = this.props;
    let keyword = '';
    if (photo?.tags?.length > 0) {
      keyword = photo.tags[0][`name_${lng === 'jp' ? 'ja' : lng}`];
    }
    if (!collection || collection.length === 0) return;

    const newCollection = collection.map((item) => {
      return {
        ...item,
        title:
          typeof item.title === 'string' ? JSON.parse(item.title) : item.title,
      };
    });

    return (
      <SimilarOtherService
        title={this.renderTitleSimilar(SERVICE_TYPES.ILLUST_AC)}
        collection={newCollection}
        serviceType={SERVICE_TYPES.ILLUST_AC}
        dataID={id}
        t={t}
        lng={lng}
        keyword={keyword}
      />
    );
  };

  renderActionImage = () => {
    const { t, photo, isBookmark } = this.props;
    return (
      <div className="container-action">
        <div className="left-action">
          {/* remove comment for release bookmark feature */}
          {/* <div
            className={clsx('bookmark', {
              active: isBookmark,
            })}
            onClick={this.saveBookmark}
          >
            {isBookmark ? <IconBookmarked /> : <IconBookmark />}
            <p className="text-like-action">
              {isBookmark ? t('saved') : t('Save')}
            </p>
          </div> */}
          <div className="like" onClick={this.nicePhoto}>
            {photo.is_nice ? (
              <IconLikeService height={'22'} />
            ) : (
              <>
                <IconLikeDefault height={'22'} className="icon-like-default" />
                <IconLikeServiceHover
                  height={'22'}
                  className="icon-like-active"
                />
              </>
            )}
            <p className="text-like-action">{photo?.nice || 0}</p>
          </div>
        </div>
        <div className="right-action">
          <span className="icon-safety">
            <img
              src={`${Config.staticPrefix}/static/assets/image/download-pages/antivirus.svg`}
              width={'24'}
              height={'24'}
              alt="icon safety"
            />
          </span>
          <p>SAFETY</p>
        </div>
        <style jsx global>
          {`
            .popover {
              max-width: 400px;
            }
            .content-container {
              display: flex;
              flex-direction: column;
              min-width: 360px;
              padding: 8px;
            }
            .social-shares-popover {
              width: 500px;
            }
            @media (max-width: ${themeVariables.breakpoints.mobile
                .maxWidth}px) {
              .content-container {
                padding: 0px;
                min-width: 300px;
                padding: 4px;
              }
              .social-shares-popover {
                width: 100%;
              }
            }
          `}
        </style>
        <style jsx>
          {`
            .share:hover .icon-share-org {
              display: none;
            }
            .container-count-photo {
              display: flex;
              margin-left: 4px;
            }
            .container-arrow-left {
              display: flex;
              flex-direction: column;
              justify-content: center;
            }
            .arrow-left {
              border-left: 10px solid transparent;
              border-right: 10px solid transparent;
              border-bottom: 12px solid #ffffff;
              filter: drop-shadow(0px -1px 1px rgba(0, 0, 0, 0.5));

              margin-left: 8px;
              z-index: 1000;
            }
            .container-action {
              width: 100%;
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              margin-top: 16px;
            }
            .left-action {
              display: flex;
            }
            .bookmark,
            .like,
            .share {
              display: flex;
              flex-direction: column;
              align-items: center;
              height: 58px;
              justify-content: space-between;
              cursor: pointer;
              margin-right: 16px;
            }
            @media (max-width: ${themeVariables.breakpoints.mobile
                .maxWidth}px) {
              .bookmark,
              .like,
              .share {
                height: 48px;
              }
            }
            .bookmark > p,
            .like > p,
            .share > p {
              margin: 0;
            }
            .right-action {
              display: flex;
              align-items: center;
              width: 120px;
              height: 40px;
              border-radius: 4px;
              border: 1px solid #170507;
              overflow: hidden;
            }
            .right-action .icon-safety {
              height: 40px;
              width: 40px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-right: 1px solid #170507;
            }
            .right-action > p {
              margin: 0;
              font-weight: bold;
              background: #e3e3e3;
              height: 40px;
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .container-social {
              position: relative;
            }
            .content-social {
              position: absolute;
              z-index: 999;
              background: #ffffff;
              border-radius: 4px;
              filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.5));
              padding: 8px;
            }
            .bookmark:hover {
              color: ${themeVariables.colors.primary};
            }
            .bookmark.active {
              color: ${themeVariables.colors.primary};
            }
          `}
        </style>
      </div>
    );
  };

  render() {
    const {
      title,
      path,
      thumbnail,
      statistics,
      silhouetteSimilar,
      photoSimilar,
      designSimilar,
      id,
      dataType,
      powerPoint,
      photo,
      loadingExtraLicensePayment,
      testModal,
      t,
      lng,
    } = this.props;
    let keyword = '';
    if (photo?.tags?.length > 0) {
      keyword = photo.tags[0][`name_${lng === 'jp' ? 'ja' : lng}`];
    }
    let { imagesPreview } = this.props;
    if (imagesPreview.length < 1 && thumbnail) {
      imagesPreview = imagesPreview.concat({ path, thumbnail });
    }

    let isHavingData;
    switch (dataType) {
      case 'ppt':
        isHavingData = powerPoint;
        break;
      case 'wtp':
        isHavingData = imagesPreview && imagesPreview.length >= 1;
        break;
      case 'ads':
        isHavingData = imagesPreview && imagesPreview.length >= 1;
        break;
      default:
        isHavingData = imagesPreview && imagesPreview.length >= 1;
    }

    const loadingExtraLicensePaymentMessage =
      loadingExtraLicensePayment.fullScreen &&
      t('register_premium_message_pay');
    console.log('hihi title ne', title);

    return (
      <div className="photo-page">
        {isHavingData && (
          <AttributeModal
            photo={photo}
            modal={this.props.modal}
            handleClose={this.props.showAttributeModal}
          />
        )}
        {lng === 'en' && <NewSurvey t={t} />}
        <Container style={{ marginTop: 24 }}>
          <div className="download-page-title">
            <h1>{`${t('ill_download_page_title')}: ${title.replace(
              '&#39;',
              "'",
            )}`}</h1>
          </div>
        </Container>
        {isHavingData ? (
          <>
            <UserChecking number={statistics.peopleViewing} />
            <TimeDownload date={statistics.latsDownload} />
            <div className="data-section-desktop">
              {this.renderDataSection()}
            </div>
            <div className="data-section-mobile">
              {this.renderDataSectionMobile()}
            </div>
          </>
        ) : (
          this.renderNoData()
        )}
        <div className="other-service-desktop">
          <Container>
            {/* Similar image sections - START */}
            {this.renderSameCreatorDataSection()}
            {photoSimilar && photoSimilar.length > 0 && (
              <SimilarOtherService
                title={this.renderTitleSimilar(SERVICE_TYPES.PHOTO_AC)}
                collection={photoSimilar}
                serviceType={SERVICE_TYPES.PHOTO_AC}
                dataID={id}
                t={t}
                lng={lng}
                keyword={keyword}
              />
            )}
            {silhouetteSimilar && silhouetteSimilar.length > 0 && (
              <SimilarOtherService
                title={this.renderTitleSimilar(SERVICE_TYPES.SILHOUETTE_AC)}
                collection={silhouetteSimilar}
                serviceType={SERVICE_TYPES.SILHOUETTE_AC}
                dataID={id}
                t={t}
                lng={lng}
                keyword={keyword}
              />
            )}
            {designSimilar && designSimilar.length > 0 && (
              <SimilarOtherService
                title={this.renderTitleSimilar(SERVICE_TYPES.DESIGN_AC)}
                collection={designSimilar}
                serviceType={SERVICE_TYPES.DESIGN_AC}
                dataID={id}
                t={t}
                lng={lng}
                keyword={keyword}
              />
            )}
          </Container>
        </div>
        {testModal && <ExtraLicensePaymentModal />}
        <div
          className="container-comments-data"
          ref={this.commentContainerRef}
          onScroll={this.onScroll}
        >
          <Container>
            {/* {commentList.length > 0 && <Comment comments={commentList} />} */}
            <Comment id={id} t={t} />
          </Container>
        </div>
        <LoadingDefault
          {...loadingExtraLicensePayment}
          message={loadingExtraLicensePaymentMessage}
        />
        <style jsx>
          {`
            .photo-page {
              margin-bottom: 64px;
            }
            .data-text-unlogin {
              font-size: 14px;
              font-weight: normal;
              color: #333333;
              display: flex;
              justify-content: flex-end;
              padding-top: 12px;
            }
          `}
        </style>
        <style jsx global>
          {`
            .download-page-title {
              height: 40px;
            }
            .link-to {
              font-weight: 700;
            }
            .link-to:hover {
              opacity: 0.9 !important;
              text-decoration: underline !important;
            }
            .link-to:focus {
              opacity: 1 !important;
              text-decoration: none !important;
            }
            .download-page-title h1 {
              font-weight: 600;
              font-size: 20px;
              line-height: 23px;
              color: #170507;
              margin: 0;
            }
            .photo-page .data-section-mobile {
              display: none;
            }
            .photo-page .similar-image {
              position: relative;
              text-align: center;
              width: calc(100%);
              margin: auto;
            }
            .photo-page .similar-image .slide-image {
              width: auto;
              height: 150px;
              border-radius: 2px;
            }
            .photo-page .photo-wrapper {
              display: flex;
              justify-content: center;
              padding-bottom: 12px;
            }
            .photo-page .photo-wrapper .photo-section-right {
              margin-left: 24px;
              position: sticky;
              top: 75px;
              padding-bottom: 0.6em;
              width: 400px;
            }
            @media (max-width: 767px) {
              .photo-page .photo-wrapper {
                display: block;
              }
              .photo-page .photo-wrapper .photo-section-right {
                width: 100%;
                margin-left: 0;
                margin-top: 20px;
              }
              .photo-page .photo-wrapper .sticky-right {
                width: 100%;
              }
            }
            @media (max-width: ${themeVariables.breakpoints.tabletS
                .maxWidth}px) {
              .photo-page .data-section-desktop {
                display: none;
              }
              .photo-page .data-section-mobile {
                display: block;
              }
              .photo-page .photo-wrapper .photo-section-right {
                width: 100%;
                margin-left: 0;
                margin-top: 20px;
              }
              .photo-page .similar-image {
                width: calc(100%);
              }
              .download-page-title h1 {
                font-size: 18px;
                text-align: center;
              }
            }

            .photo-page .title_similar {
              padding-left: 3px;
              padding-right: 40px;
              font-size: 14px;
            }

            .photo-page .facebook_like_widget,
            .photo-page .ac-license {
              margin-top: 14px;
              margin-bottom: 14px;
              padding: 14px;
              background: #fff;
              font-size: 14px;
              border-radius: 2px;
            }

            .photo-page .ac-license {
              display: flex;
              align-items: center;
            }
            .photo-page .ac-license .license-check-list {
              border-left: 1px solid #ccc;
              padding-left: 14px;
            }
            .photo-page .ac-license .license-check-list .how_attribute {
              margin-left: 18px;
              text-decoration: underline;
              cursor: pointer;
            }

            .photo-page .facebook_like_widget {
              max-height: 200px;
            }

            .current-thumbnail-arrow {
              display: block;
              position: absolute;
              right: -20px;
              top: 70px;
            }

            @media only screen and (max-width: 768px) {
              .container {
                padding-right: 0px;
                padding-left: 0px;
                margin-right: auto;
                margin-left: auto;
              }
              .download-page-title {
                height: unset;
                font-size: 18px;
              }
              .download-page-title h1 {
                margin-left: 0;
              }
            }
            .container-fluid ul li {
              list-style: none;
              padding: 0 25px;
            }
            .responsive-folder-button {
              margin-top: 7px;
              margin-left: 0px;
            }
            .responsive-folder-button.col-sm-6 {
              margin-top: 0;
            }
            .next-similar {
              display: flex;
              justify-content: space-between;
            }
            .statistics-content {
              text-align: center;
            }
            .icon-share-active {
              display: none;
            }
            .share:hover .icon-share-active {
              display: block;
            }
            .share:hover .icon-share-default {
              display: none;
            }
            .icon-like-active {
              display: none;
            }
            .like:hover .icon-like-active {
              display: none;
            }
            .like:hover .icon-like-active {
              display: block;
            }
            .like:hover .icon-like-default {
              display: none;
            }
            .share:hover .text-share-action {
              color: ${themeVariables.colors.primary};
            }
            .like:hover .text-like-action {
              color: ${themeVariables.colors.primary};
            }
          `}
        </style>
      </div>
    );
  }
}
const mapStateToProps = createStructuredSelector({
  id: makeSelectId(),
  tags: makeSelectPhotoTags(),
  categories: makeSelectPhotoCategories(),
  title: makeSelectPhotoTitle(),
  nice: makeSelectPhotoNice(),
  assets: makeSelectPhotoAssets(),
  imagesPreview: makeSelectPhotoPreview(),
  isAuthenticated: makeSelectIsAuthenticated(),
  creator: makeSelectCreator(),
  assetSelected: makeSelectAssetSelected(),
  downloadPhotoLoading: makeSelectDownloadPhotoLoading(),
  downloadingPhoto: makeSelectDownloadingPhoto(),
  gotItModal: makeSelectGotIt(),
  statistics: makeSelectStatistics(),
  path: makeSelectPhotoPath(),
  base64: makeSelectPhotoBase64(),
  thumbnail: makeSelectPhotoThumbnail(),
  silhouetteSimilar: makeSelectSilhouetteSimilar(),
  photoSimilar: makeSelectPhotoSimilar(),
  language: makeSelectCurrentLang(),
  collection: makeSelectCollection(),
  designSimilar: makeSelectDesignSimilar(),
  illustSimilar: makeSelectIllustSimilar(),
  sameCreator: makeSelectSameCreator(),
  serviceType: makeSelectServiceType(),
  categoriesDesign: makeSelectCategoryDesign(),
  categorySimilar: makeSelectCategorySimilar(),
  profile: makeSelectProfile(),
  dataType: makeSelectDataType(),
  powerPoint: makeSelectPowerPoint(),
  photo: makeSelectPhoto(),
  hasTrial: makeSelectIsTrial(),
  currentLanguage: makeSelectCurrentLanguage(),
  patterns: makeSelectPatterns(),
  neighbor: makeSelectNeighbor(),
  modal: makeSelectModalAttribute(),
  loadingExtraLicensePayment: makeSelectLoadingExtraLicensePayment(),
  testModal: makeSelectModal(),
  photoDetail: selectDetailPhoto,
  similar: selectSimilar,
  isBookmark: makeSelectBookmarkData(),
});
const mapDispatchToProps = (dispatch) => ({
  assetSelect: (index) => dispatch(assetSelect(index)),
  assetSelectIndex: (index) => dispatch(assetSelectIndex(index)),
  downloadPhoto: (params) => dispatch(downloadPhoto(params)),
  nicePhoto: (id) => dispatch(nicePhoto(id)),
  showAttributeModal: (modal) => dispatch(showAttributeModal(modal)),
  loadPhotosInCart: () => dispatch(loadPhotosInCart()),
  checkBookmarkData: (params) => dispatch(checkBookmarkData(params)),
  saveBookmark: (params) => dispatch(saveBookmark(params)),
  loadCommentsData: (params) => dispatch(loadCommentsData(params)),
});
export default connect(mapStateToProps, mapDispatchToProps)(IllustContainer);
